import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class InvoiceReportData extends ReportData<InvoiceReportData> {
    @field receiptNo: string;
    @field outletId: number;
}
